module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
var css = {};
css[Reports.Status.Created] = "created";
css[Reports.Status.Processing] = "processing";
css[Reports.Status.Ready] = "ready";

    ; __append("\n<div class=\"item ")
    ; __append(escapeFn( css[+item.report.status] ))
    ; __append("\" data-section=\"")
    ; __append(escapeFn( item.section ))
    ; __append("\"\n	 data-id=\"")
    ; __append(escapeFn( item.report.id ))
    ; __append("\" ")
    ;  if (item.report.status == Reports.Status.Ready) { 
    ; __append("on-click=\"onShowClick\"\n	")
    ;  } 
    ; __append("\n	>\n	")
    ; 
	var iconCssClass = null;

	if (item.report.format == Reports.Format.Excel) {
		iconCssClass = "icon-file-excel";
	}

	if (item.report.format == Reports.Format.Word) {
		iconCssClass = "icon-file-word";
	}
	
    ; __append("\n\n	<div>\n		")
    ;  if (iconCssClass) { 
    ; __append("\n			<i class=\"icon ")
    ; __append(escapeFn( iconCssClass ))
    ; __append("\" title=\"")
    ; __append(escapeFn( Reports.Format.title(item.report.format) ))
    ; __append("\"></i>\n		")
    ;  } 
    ; __append("\n\n		<h3 style=\"margin: 0 0 12px; font-size: 18px\">")
    ; __append(escapeFn( item.name ))
    ; __append("</h3>\n	</div>\n\n	")
    ;  if (item.parameters && !Util.isEmpty(item.parameters)) { 
    ; __append("\n	<div>\n		")
    ;  Util.each(item.parameters, function (param) { 
    ; __append("\n		")
    ;  if (param.value) { 
    ; __append("\n		<p><b>")
    ; __append(escapeFn( param.name ))
    ; __append("</b>: ")
    ; __append(escapeFn( param.value ))
    ; __append("</p>\n		")
    ;  } 
    ; __append("\n		")
    ;  }); 
    ; __append("\n	</div>\n	")
    ;  } 
    ; __append("\n\n	<div>\n		<h4 style=\"font-size: 14px; margin: 0\">")
    ; __append(escapeFn( Reports.Status.title(item.report.status) ))
    ; __append("</h4>\n	</div>\n</div>\n")
  }
  return __output.join("");

}